import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { eventsDashboardGuard } from './core/guards/events-dashboard.guard';
import {
  TAB_EVENT_ID_PAGE,
  TAB_EVENTS_PAGE,
  TAB_LOAD_PAGE,
  TAB_PATROL_PAGE,
  TAB_SITE_CHECK_PAGE,
  TAB_WAITING_PAGE,
} from './core/routing/browser-tab-routes';
import { ActionLoadingPage } from './features/events/pages/action-loading/action-loading';
import { EscalationWaitingPage } from './features/events/pages/escalation-waiting/escalation-waiting';
import { EventViewPage } from './features/events/pages/event-view/event-view';
import { EventsDashboard } from './features/events/pages/events-dashboard/events-dashboard';
import { Login } from './features/login/components/login/login';
import { eventqOktaCallbackRoute } from './core/auth/okta-redirect';
import { LoginOktaCallback } from './features/login/components/login-okta-callback/login-okta-callback';
import { AgentShell } from './shared/layout/agent-shell/agent-shell';

const agentTabChildren: Routes = [
  { path: '', redirectTo: TAB_EVENTS_PAGE, pathMatch: 'full' },
  {
    path: TAB_EVENTS_PAGE,
    component: EventsDashboard,
    canActivate: [eventsDashboardGuard],
  },
  { path: TAB_WAITING_PAGE, component: EscalationWaitingPage },
  {
    path: `${TAB_LOAD_PAGE}/manual-patrol`,
    component: ActionLoadingPage,
    data: { message: 'Loading Patrol' },
  },
  {
    path: `${TAB_LOAD_PAGE}/site-check`,
    component: ActionLoadingPage,
    data: { message: 'Loading Site Check' },
  },
  {
    path: `${TAB_LOAD_PAGE}/process-event`,
    component: ActionLoadingPage,
    data: { message: 'Loading Next Event' },
  },
  {
    path: `${TAB_LOAD_PAGE}/raise-to-resolve`,
    component: ActionLoadingPage,
    data: { message: 'Raising Event' },
  },
  {
    path: `${TAB_LOAD_PAGE}/close-event`,
    component: ActionLoadingPage,
    data: { message: 'Closing Event' },
  },
  {
    path: `${TAB_LOAD_PAGE}/park-event`,
    component: ActionLoadingPage,
    data: { message: 'Parking Event' },
  },
  {
    path: `${TAB_EVENT_ID_PAGE}/:eventId`,
    component: EventViewPage,
    data: { processingMode: 'process-event' },
  },
  {
    path: `${TAB_SITE_CHECK_PAGE}/:eventId`,
    component: EventViewPage,
    data: { processingMode: 'site-check' },
  },
  {
    path: `${TAB_PATROL_PAGE}/:eventId`,
    component: EventViewPage,
    data: { processingMode: 'manual-patrol' },
  },
];

const legacyAgentRedirects: Routes = [
  { path: 'events', redirectTo: 't1/events', pathMatch: 'full' },
  { path: 'events/:tabId', redirectTo: 't:tabId/events', pathMatch: 'full' },
  { path: 'events/:tabId/e/:eventId', redirectTo: 't:tabId/event-id/:eventId' },
  { path: 'events/:tabId/load/:action', redirectTo: 't:tabId/load/:action' },
  { path: 'events/:tabId/loading/:action', redirectTo: 't:tabId/load/:action' },
  { path: 'events/:tabId/event/:eventId', redirectTo: 't:tabId/event-id/:eventId' },
  { path: 'events/t/:tabId', redirectTo: 't:tabId/events', pathMatch: 'full' },
  {
    path: 'events/t/:tabId/e/:eventId',
    redirectTo: 't:tabId/event-id/:eventId',
  },
  {
    path: 'events/t/:tabId/load/:action',
    redirectTo: 't:tabId/load/:action',
  },
  {
    path: 'events/t/:tabId/loading/:action',
    redirectTo: 't:tabId/load/:action',
  },
];

export const routes: Routes = [
  { path: eventqOktaCallbackRoute(), component: LoginOktaCallback },
  { path: 'login', component: Login },
  { path: 'login/callback', component: LoginOktaCallback },
  {
    path: '',
    component: AgentShell,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 't1/events', pathMatch: 'full' },
      ...legacyAgentRedirects,
      {
        path: ':tabKey',
        children: agentTabChildren,
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
